import { useCallback, useState } from 'react';

const useOnScreen = ({ root = null, rootMargin = '0px', threshold = 0 } = {}) => {
    const [startObserver, setStartObserver] = useState();
    const [endObserver, setEndObserver] = useState();
    const [isStartIntersecting, setStartIntersecting] = useState(false);
    const [isEndIntersecting, setEndIntersecting] = useState(false);

    const measureEndRef = useCallback(
        (node) => {
            if (node) {
                const observer = new IntersectionObserver(
                    ([entry]) => {
                        setEndIntersecting(entry.isIntersecting);
                    },
                    { root, rootMargin, threshold },
                );

                observer.observe(node);
                setEndObserver(observer);
            }
        },
        [root, rootMargin, threshold],
    );

    const measureStartRef = useCallback(
        (node) => {
            if (node) {
                const observer = new IntersectionObserver(
                    ([entry]) => {
                        setStartIntersecting(entry.isIntersecting);
                    },
                    { root, rootMargin, threshold },
                );

                observer.observe(node);
                setStartObserver(observer);
            }
        },
        [root, rootMargin, threshold],
    );

    return {
        measureStartRef,
        measureEndRef,
        isStartIntersecting,
        isEndIntersecting,
        startObserver,
        endObserver,
    };
};

export default useOnScreen;
